import React from 'react';
import styles from '../OrderStatus.module.css';
import buttonStyles from '../../../styles/buttons.module.css';
import validate from './validate';

const initialForm = {
  purchase_id: '',
  purchase_key: ''
}

const ValidationForm = (props) => {

  const [form, setForm] = React.useState(initialForm);
  const [errors, setErrors] = React.useState([]);

  React.useEffect(() => {
    if (props.formInvalid) {
      setErrors(['Error fetching order details. Make sure both fields are correct.'])
    }
  }, [props.formInvalid]);

  React.useEffect(() => {
    if (props.linkInvalid) {
      setErrors(['Link bad or expired. Fill out the above form to view order status.'])
    }
  }, [props.linkInvalid]);

  function handleTextChange(e, field) {
    setForm({ ...form, [field]: e.target.value });
  }

  function submit(e) {
    e.preventDefault();

    const formErrors = validate(form);
    setErrors(formErrors);

    if (formErrors.length == 0) {
      props.getValidatorToken(form.purchase_id, form.purchase_key);
    }
  }

  return (
    <div className='container fluid'>
      <div className='row'>
        <h2 style={{ textAlign: 'left' }}>{props.pageAction.toUpperCase()}</h2>
        <p style={{ padding: 3 }}>
          To {props.pageAction}, enter your order number, and for security reasons
          we require either the zip code for the address to which the package was shipped,
          or a phone number on the order.
        </p>
      </div>
      <div className='row'>
        <form onSubmit={(e) => submit(e)}>
          <table>
            <tbody>
              <tr>
                <td style={{ textAlign: 'right', fontWeight: 'bold', padding: 3 }}>
                  Order Number*:
                </td>
                <td style={{ padding: 3 }}>
                  <input
                    type='text'
                    value={form.purchase_id}
                    onChange={(e) => handleTextChange(e, 'purchase_id')}
                  />
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: 'right', fontWeight: 'bold', padding: 3 }}>
                  Ship Zip Code or Phone*:
                </td>
                <td style={{ padding: 3 }}>
                  <input
                    type='text'
                    value={form.purchase_key}
                    onChange={(e) => handleTextChange(e, 'purchase_key')}
                  />
                </td>
              </tr>
              <tr>
                <td></td>
                <td style={{ padding: 3 }}>
                  <button
                    type='submit'
                    className={buttonStyles.submitButton}
                  >
                    Submit
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          {errors.length > 0 &&
            errors.map(error => {
              return <p key={error} className={styles.error}>{error}</p>
            })
          }
        </form>
      </div>
    </div>
  );
};

export default ValidationForm;
